/**
 * The room the support launcher takes from the right edge, gap included. The launcher floats over
 * the bottom-right corner of every app page and sets this; phone toasts and list pagination read
 * it to end short of that corner. Where no launcher is mounted (admin2) it stays unset and the
 * fallback leaves those layouts as they were.
 */
export const SUPPORT_CHAT_INSET_VAR = '--support-chat-inset'

export const supportChatInset = `var(${SUPPORT_CHAT_INSET_VAR}, 0px)`
